import React from 'react'
import classNames from 'classnames'
import { Base } from '@crossfit/ui'

import style from './style.module.css'

type TabsProps = React.ComponentProps<typeof Base>

export function Tabs({ className, ...props }: TabsProps) {
  return (
    <Base as='nav' className={classNames(style.tabs, className)} {...props} />
  )
}

type TabProps = React.ComponentProps<typeof Base> & {
  isActive?: boolean
}

export function Tab({ as = 'a', className, isActive, ...props }: TabProps) {
  return (
    <Base
      as={as}
      role='tab'
      className={classNames(style.tab, { [style.active]: isActive }, className)}
      {...props}
    />
  )
}
